// import React, { useState, useEffect } from "react";
// import { Link } from "react-router-dom";
// import Slider from "react-slick";

// const NewArrivalTwo = ({ currentProduct }) => {
//   const [recommendedProducts, setRecommendedProducts] = useState([]);
//   const [loading, setLoading] = useState(true);

//   useEffect(() => {
//     if (!currentProduct?._id) return;
//     fetchRecommendedProducts(currentProduct._id);
//   }, [currentProduct]);

//   const fetchRecommendedProducts = async (productId) => {
//     try {
//       setLoading(true);

//       const res = await fetch(
//         `${process.env.REACT_APP_API_URL}/keyword/products/${productId}/recommendations?limit=10`
//       );
//       const data = await res.json();

//       setRecommendedProducts(data.recommendations || []);
//     } catch (error) {
//       console.error("Error fetching recommendations:", error);
//     } finally {
//       setLoading(false);
//     }
//   };

//   function SampleNextArrow(props) {
//     const { className, onClick } = props;
//     return (
//       <button
//         type="button"
//         onClick={onClick}
//         className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
//       >
//         <i className="ph ph-caret-right" />
//       </button>
//     );
//   }

//   function SamplePrevArrow(props) {
//     const { className, onClick } = props;
//     return (
//       <button
//         type="button"
//         onClick={onClick}
//         className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
//       >
//         <i className="ph ph-caret-left" />
//       </button>
//     );
//   }

//   const settings = {
//     dots: false,
//     arrows: true,
//     infinite: recommendedProducts.length > 6,
//     speed: 1000,
//     slidesToShow: Math.min(6, recommendedProducts.length),
//     slidesToScroll: 1,
//     nextArrow: <SampleNextArrow />,
//     prevArrow: <SamplePrevArrow />,
//     responsive: [
//       { breakpoint: 1399, settings: { slidesToShow: Math.min(4, recommendedProducts.length) }},
//       { breakpoint: 992,  settings: { slidesToShow: Math.min(3, recommendedProducts.length) }},
//       { breakpoint: 575,  settings: { slidesToShow: Math.min(2, recommendedProducts.length) }},
//       { breakpoint: 424,  settings: { slidesToShow: 1 }},
//     ],
//   };

//   if (loading) {
//     return (
//       <section className="new-arrival pb-60">
//         <div className="container text-center py-5">
//           <p>Loading recommendations...</p>
//         </div>
//       </section>
//     );
//   }

//   if (!recommendedProducts.length) return null;

//   return (
//     <section className="new-arrival pb-20">
//       <div className="container container-lg">
//         <div className="section-heading flex-between flex-wrap gap-8 mb-6">
//           <h5 className="mb-0">You Might Also Like</h5>
//           <Link to="/shop" className="text-sm fw-medium">All Products</Link>
//         </div>

//         <Slider {...settings}>
//           {recommendedProducts.map((product) => (
//             <div key={product._id}>
//               <div className="product-card h-100 p-8 border border-gray-100 hover-border-main-600 rounded-16 transition-2 bg-white hover:shadow-md">
//                 <Link to={`/product-details/${product._id}`} className="product-card__thumb flex-center">
//                   <img
//                     src={product.image || product.images?.[0] || "/assets/images/thumbs/default-product.png"}
//                     alt={product.name}
//                     className="max-h-[150px] object-contain"
//                   />
//                 </Link>

//                 <div className="product-card__content p-sm-2 mt-2 text-center">
//                   <h6 className="title text-md fw-semibold mt-12 mb-6">
//                     <Link to={`/product-details/${product._id}`} className="link text-line-2">
//                       {product.name}
//                     </Link>
//                   </h6>
//                   <p className="text-xs text-gray-600 mb-2 line-clamp-2 px-2">
//                     {product.description?.slice(0, 60)}...
//                   </p>

//                   <div className="text-md fw-bold text-main-600 mb-1">
//                     ₹{product.price}
//                   </div>

//                   {/* Rating */} 
//                   <div className="product-card__rating flex-align justify-center mb-6 gap-6">
//                     {(() => {
//                       const reviews = product.reviews || [];
//                       const total = reviews.length;

//                       const avg =
//                         total > 0 ? (reviews.reduce((sum, r) => sum + (r.ratings || 0), 0) / total).toFixed(1) : "0.0";

//                       return (
//                         <>
//                           <span className="text-xs fw-bold text-gray-600">{avg}</span>
//                           <span className="text-15 fw-bold text-warning-600 d-flex"><i className="ph-fill ph-star" /></span>
//                           <span className="text-xs fw-bold text-gray-600">({total})</span>
//                         </>
//                       );
//                     })()}
//                   </div>

//                   {/* <div className="text-xs text-gray-500">
//                     Match Score: <span className="text-main-600 fw-semibold">{product.score?.toFixed(2)}</span>
//                   </div> */}
//                 </div>
//               </div>
//             </div>
//           ))}
//         </Slider>
//       </div>
//     </section>
//   );
// };

// export default NewArrivalTwo;


import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import Slider from "react-slick";

const getCurrencySymbol = (currency) => {

  switch (currency) {

    case "INR":
      return "₹";

    case "USD":
      return "$";

    case "EUR":
      return "€";

    case "AED":
      return "AED ";

    case "SAR":
      return "SAR ";

    case "QAR":
      return "QAR ";

    case "GBP":
      return "£";

    default:
      return "$";
  }
};

const MAX_SWATCHES = 4;

/* ─── Single Product Card ─────────────────────────────────── */
const ProductCard = ({ product, selectedCurrency }) => {
  const variants = product.variants || [];

  const colorVariants = variants.filter(
    (v) => v.color || v.colorName || v.colorCode || v.colorHex
  );

  const hasColors = colorVariants.length > 0;
  const [activeIdx, setActiveIdx] = useState(-1);

  const activeVariant = activeIdx >= 0 ? colorVariants[activeIdx] : null;

  const displayImage =
    activeVariant?.images?.[0] ||
    activeVariant?.image ||
    product.image ||
    product.images?.[0] ||
    "/assets/images/thumbs/default-product.png";

  const variantPrice =
  activeVariant?.price ||
  product?.variants?.[0]?.price ||
  product?.price ||
  {};

const displayPrice =
  typeof variantPrice === "object"
    ? (
        variantPrice?.[
          selectedCurrency
        ] ||

        variantPrice?.INR ||

        0
      )
    : variantPrice || 0;

const variantOldPrice =
  activeVariant?.oldPrice ||
  product?.variants?.[0]?.oldPrice ||
  product?.oldPrice ||
  null;

const displayOldPrice =
  typeof variantOldPrice === "object"
    ? (
        variantOldPrice?.[
          selectedCurrency
        ] ||

        variantOldPrice?.INR ||

        0
      )
    : variantOldPrice;

  const reviews = product.reviews || [];
  const total   = reviews.length;
  const avg     =
    total > 0
      ? (reviews.reduce((s, r) => s + (r.ratings || 0), 0) / total).toFixed(1)
      : "0.0";

  const swatchColor = (v) =>
    v.colorHex || v.colorCode || v.color || v.colorName || "#ccc";

  const visibleSwatches = colorVariants.slice(0, MAX_SWATCHES);
  const extraCount      = colorVariants.length - MAX_SWATCHES;

  

  return (
    <div className="nat-card">
      {/* Image */}
      <Link to={`/product-details/${product._id}`} className="nat-card__thumb">
        <img src={displayImage} alt={product.name} className="nat-card__img" />
      </Link>

      {/* Colour swatches */}
      {hasColors && (
        <div className="pl-swatches">
          {visibleSwatches.map((v, i) => (
            <button
              key={i}
              className={`pl-swatch ${activeIdx === i ? "pl-swatch--active" : ""}`}
              style={{ background: swatchColor(v) }}
              title={v.colorName || v.color || `Color ${i + 1}`}
              onClick={() => setActiveIdx(activeIdx === i ? -1 : i)}
              aria-label={`Select color ${v.colorName || i + 1}`}
            />
          ))}
          {extraCount > 0 && (
            <Link to={`/product-details/${product._id}`} className="pl-swatch-more">
              +{extraCount}
            </Link>
          )}
        </div>
      )}

      {/* Content */}
      <div className="nat-card__content">
        <h6 className="nat-card__name">
          <Link to={`/product-details/${product._id}`} title={product.name}>
            {product.name}
          </Link>
        </h6>

        {product.description && (
          <p className="nat-card__desc">
            {product.description.slice(0, 60)}…
          </p>
        )}

        <div className="nat-card__rating">
          <span className="pl-rating__avg">{avg}</span>
          <span className="pl-rating__star"><i className="ph-fill ph-star" /></span>
          <span className="pl-rating__count">({total})</span>
        </div>

        <div className="nat-card__price">

  {displayOldPrice && (
    <span className="pl-price--old">

      {getCurrencySymbol(
        selectedCurrency
      )}

      {Number(
        displayOldPrice
      ).toFixed(2)}

    </span>
  )}

  <span className="pl-price--now">

    {getCurrencySymbol(
      selectedCurrency
    )}

    {Number(
      displayPrice
    ).toFixed(2)}

  </span>

</div>
      </div>
    </div>
  );
};

/* ─── Arrows ──────────────────────────────────────────────── */
function SampleNextArrow({ className, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-next slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-right" />
    </button>
  );
}

function SamplePrevArrow({ className, onClick }) {
  return (
    <button
      type="button"
      onClick={onClick}
      className={`${className} slick-prev slick-arrow flex-center rounded-circle border border-gray-100 hover-border-main-600 text-xl hover-bg-main-600 hover-text-white transition-1`}
    >
      <i className="ph ph-caret-left" />
    </button>
  );
}

/* ─── Main Component ───────────────────────────────────────── */
const NewArrivalTwo = ({ currentProduct, selectedCurrency }) => {
  const [recommendedProducts, setRecommendedProducts] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!currentProduct?._id) return;
    fetchRecommendedProducts(currentProduct._id);
  }, [currentProduct]);

  const fetchRecommendedProducts = async (productId) => {
    try {
      setLoading(true);
      const res = await fetch(
        `${process.env.REACT_APP_API_URL}/keyword/products/${productId}/recommendations?limit=10`
      );
      const data = await res.json();
      setRecommendedProducts(data.recommendations || []);
    } catch (error) {
      console.error("Error fetching recommendations:", error);
    } finally {
      setLoading(false);
    }
  };

  const count = recommendedProducts.length;

  const settings = {
    dots: false,
    arrows: true,
    infinite: count > 6,
    speed: 1000,
    slidesToShow: Math.min(6, count),
    slidesToScroll: 1,
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    responsive: [
      { breakpoint: 1399, settings: { slidesToShow: Math.min(4, count) } },
      { breakpoint: 992,  settings: { slidesToShow: Math.min(3, count), arrows: false } },
      { breakpoint: 575,  settings: { slidesToShow: Math.min(2, count), arrows: false } },
      { breakpoint: 424,  settings: { slidesToShow: 1, arrows: false } },
    ],
  };

  if (loading) {
    return (
      <section className="new-arrival pb-60">
        <div className="container text-center py-5">
          <p>Loading recommendations...</p>
        </div>
      </section>
    );
  }

  if (!count) return null;

  return (
    <section className="new-arrival pb-20">
      <div className="container container-lg">

        <div className="section-heading flex-between flex-wrap gap-8 mb-16">
          <h5 className="mb-0">You Might Also Like</h5>
          <Link
            to="/shop"
            className="text-sm fw-medium text-gray-900 hover-text-main-600 hover-text-decoration-underline"
          >
            All Products
          </Link>
        </div>

        <Slider {...settings}>
          {recommendedProducts.map((product) => (
            <div key={product._id} className="nat-slide-wrap">
              <ProductCard product={product} selectedCurrency={selectedCurrency} />
            </div>
          ))}
        </Slider>
      </div>

      <style>{`
        /* ══════════════════════════════════════
           Variables
           ══════════════════════════════════════ */
        .new-arrival {
          --pl-primary: var(--main-600, #1a8a3c);
          --pl-border:  #e3e6e8;
          --pl-radius:  12px;
          --pl-text:    #111;
          --pl-sub:     #565959;
          --pl-price:   #b12704;
        }

        /* ── Slide wrapper ── */
        .nat-slide-wrap { padding: 0 6px; }

        /* ── Card ── */
        .nat-card {
          background: #fff;
          border: 1px solid var(--pl-border);
          border-radius: var(--pl-radius);
          overflow: hidden;
          display: flex;
          flex-direction: column;
          transition: box-shadow .2s, border-color .2s;
        }
        .nat-card:hover {
          box-shadow: 0 4px 16px rgba(0,0,0,0.11);
          border-color: #adb1b8;
        }

        /* ── Thumb ── */
        .nat-card__thumb {
          display: block;
          width: 100%;
          height: 180px;
          overflow: hidden;
          background: #f9fafb;
        }
        .nat-card__img {
          width: 100%; height: 100%;
          object-fit: cover;
          transition: transform .28s;
        }
        .nat-card:hover .nat-card__img { transform: scale(1.05); }

        /* ══════════════════════════════════════
           COLOUR SWATCHES
           ══════════════════════════════════════ */
        .pl-swatches {
          display: flex;
          align-items: center;
          gap: 5px;
          padding: 8px 10px 4px;
          flex-wrap: wrap;
        }
        .pl-swatch {
          width: 20px; height: 20px;
          border-radius: 50%;
          border: 2px solid transparent;
          outline: 2px solid transparent;
          cursor: pointer; padding: 0;
          transition: outline .15s, border .15s, transform .15s;
          flex-shrink: 0;
        }
        .pl-swatch:hover {
          transform: scale(1.18);
          outline: 2px solid #aaa;
          outline-offset: 1px;
        }
        .pl-swatch--active {
          border: 2px solid #fff;
          outline: 2px solid var(--pl-primary);
          outline-offset: 1px;
          transform: scale(1.12);
        }
        .pl-swatch-more {
          font-size: 11.5px;
          color: var(--pl-primary);
          font-weight: 600;
          text-decoration: none;
          white-space: nowrap;
          margin-left: 2px;
        }
        .pl-swatch-more:hover { text-decoration: underline; }

        /* Shared rating & price classes */
        .pl-rating__avg   { font-size: 12px; font-weight: 700; color: #555; }
        .pl-rating__star  { font-size: 13px; color: #f0a500; display: flex; }
        .pl-rating__count { font-size: 11.5px; color: var(--pl-sub); }
        .pl-price--now    { font-size: 15px; font-weight: 700; color: var(--pl-price); }
        .pl-price--old    { font-size: 12px; color: #888; text-decoration: line-through; }

        /* ── Card content ── */
        .nat-card__content {
          padding: 6px 10px 12px;
          display: flex; flex-direction: column; gap: 4px; flex: 1;
        }
        .nat-card__name {
          margin: 0;
          font-size: 13px; font-weight: 600; line-height: 1.35;
        }
        .nat-card__name a {
          color: var(--pl-text); text-decoration: none;
          display: -webkit-box;
          -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }
        .nat-card__name a:hover { color: var(--pl-primary); text-decoration: underline; }

        .nat-card__desc {
          font-size: 11.5px; color: var(--pl-sub);
          line-height: 1.4; margin: 0;
          display: -webkit-box;
          -webkit-line-clamp: 2; -webkit-box-orient: vertical; overflow: hidden;
        }

        .nat-card__rating { display: flex; align-items: center; gap: 3px; }

        .nat-card__price {
          display: flex; align-items: baseline; flex-wrap: wrap; gap: 6px; margin-top: 2px;
        }

        /* ══════════════════════════════════════
           RESPONSIVE
           ══════════════════════════════════════ */
        @media (max-width: 991px) {
          .nat-card__thumb   { height: 150px; }
          .nat-card__name    { font-size: 12px; }
          .pl-price--now     { font-size: 13px; }
          .nat-card__rating  { display: none; }
          .pl-price--old     { display: none; }
          .nat-card__desc    { display: none; }
        }
        @media (max-width: 575px) {
          .nat-card__thumb   { height: 130px; }
          .nat-card__content { padding: 4px 7px 10px; }
          .nat-card__name    { font-size: 11.5px; }
          .pl-price--now     { font-size: 12px; }
          .pl-swatch         { width: 16px; height: 16px; }
          .pl-swatches       { gap: 4px; padding: 6px 7px 2px; }
          .pl-swatch-more    { font-size: 10.5px; }
          .nat-slide-wrap    { padding: 0 3px; }
        }
      `}</style>
    </section>
  );
};

export default NewArrivalTwo;
